import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Lab from "@/components/site/Lab";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <main data-testid="landing-page" className="bg-ink text-foreground">
        <Nav />
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Lab />
        <Contact />
        <Footer />
        <WhatsAppFloat />
      </main>
    </LanguageProvider>
  );
}
